var MaintenanceTypeLegacyModule = /** @class */ (function () {
    function MaintenanceTypeLegacyModule() {
    }
    return MaintenanceTypeLegacyModule;
}());
export { MaintenanceTypeLegacyModule };
